import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import ReactApexChart from "react-apexcharts";
import { useTranslation } from 'react-i18next';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useRef } from 'react';
import { useBoolean } from '@fluentui/react-hooks';
import { Callout, FontWeights, Text, TooltipHost, mergeStyleSets } from '@fluentui/react';
import { useState } from 'react';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import ChartGaugeOPF from '../Chart/ChartGaugeOPF';
import { formatNumber, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';
import { useSetInicialValues } from '../../../../../../hooks/component/sKPI/useOfConsolidatedGroupConsolidatedChart';

function SG3KPI_LASTOPF(props) {
  	const { t } = useTranslation();
	const { token: currentAuth } = useSelector((state) => state.auth);

  	const { _boardVariableDataserieValues: boardVariableDataserieValues } = useSelector((state) => state.boardViewScope);

    const { 
		inputParam_ReportMode = false,
		inputParam_HideHeader = false,
		inputParam_ComponentContent = null,
		inputParam_ShowGauge = false,
		inputParam_ReportHeaderMode = false,
		inputParam_BoardStructure = null,
        inputParam_Container = null
    } = props;

	const [chartConfig, setChartConfig] = useState(null);
	useSetInicialValues(chartConfig, setChartConfig);

	const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
	const [selectedGaugeDataPointIndex, setSelectedGaugeDataPointIndex] = useState(
		inputParam_ComponentContent ? (inputParam_ComponentContent.items.length > 0 ?
			(inputParam_ComponentContent.items[0].l_vals !== undefined ? inputParam_ComponentContent.items[0].l_vals.length - 1 : 0) : 0): 0)

	const chartTitle = inputParam_ComponentContent !== null && inputParam_ComponentContent.items.length > 0 ?
		inputParam_ComponentContent.items[0].name :
		(inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart'))

	const _base = [
		{
			name: chartTitle,
			type: "column",
			data: inputParam_ComponentContent?.items.length > 0 ? (inputParam_ComponentContent.items[0].l_vals.map(({ scopeValue }) => scopeValue)) : []
		}
	]

  	const listSeriesX = inputParam_ComponentContent ? _base : []

  	const listSerieTimeY = inputParam_ComponentContent?.items.length > 0 ? inputParam_ComponentContent.items[0].l_vals.map(({ periodId }) => periodId) : [];
  
  	const _baseSerieNames = [
		{
			axisTicks: {
				show: true,
			},
			//max: (listSeriesX.length > 0) ? Math.max(...listSeriesX) + (Math.max(...listSeriesX)*0.05) : 100,
			axisBorder: {
				show: true,
				color: '#1F7BE8'
			},
			labels: {
				style: {
				colors: '#1F7BE8',
				},
				formatter: (val) => (Number.isFinite(Number(val)) ? `${Number(val).toFixed(0)}` : val),
			},
			tooltip: {
				enabled: true
			},
			title: {
				text: chartTitle,
				style: {
				color: '#1F7BE8',
				}
			},
			min: chartConfig ? chartConfig.logroMinimo : undefined,
    		max: chartConfig ? chartConfig.logroMaximo : undefined
		}
	]

	const getTitleSubTitle = () => {

		let title = '';

		
		if (boardVariableDataserieValues !== null && inputParam_ComponentContent !== null) {
			if ( (inputParam_ComponentContent.items !== null && inputParam_ComponentContent.items.length > 0) && inputParam_ComponentContent.items[0].l_dataserie !== undefined && inputParam_ComponentContent.items[0].l_dataserie.length > 0) {
				const item = boardVariableDataserieValues.find(x => x.dataserieId === (inputParam_ComponentContent.items[0].l_dataserie[0].dataSerieId));
				title = item.name;
			}
			if (inputParam_ComponentContent.items !== null && inputParam_ComponentContent.items.l_dataserie !== undefined && inputParam_ComponentContent.items.l_dataserie.length > 0) {
				const item = boardVariableDataserieValues.find(x => x.dataserieId === (inputParam_ComponentContent.items.l_dataserie[0].dataSerieId))
				title = item.name;
			}
		}

		return title
	}

	const aux_title = boardVariableDataserieValues !== null ? (boardVariableDataserieValues.find(x =>
		x.dataserieId === (inputParam_ComponentContent.items.length > 0 ?
							(inputParam_ComponentContent.items[0].l_dataserie !== undefined ?
								(inputParam_ComponentContent.items[0].l_dataserie.length > 0 ?
									inputParam_ComponentContent.items[0].l_dataserie[0].dataSerieId : 0) : 0): 0))) : 0;

	const chartRef = useRef(null);

	const styles = mergeStyleSets({
		callout: {
			width: 320,
			maxWidth: '90%',
			padding: '20px 24px',
		},
		title: {
		  	marginBottom: 12,
		  	fontWeight: FontWeights.semilight,
		}
	});

	return  <Card className='board-element-form h-100'>
				{
					!inputParam_HideHeader &&
					<>
						{
							inputParam_ReportHeaderMode ?
							<Card.Body className='p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
								<TooltipHost content={inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}>
									<div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
										{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}
									</div>
								</TooltipHost>
							</Card.Body> :
							<Card.Header className="card-header-compact">
								<Card.Title className="d-flex justify-content-between">
									{
										aux_title !== undefined && aux_title !== 0 &&
										<b>{aux_title.variableName}</b>
									}
									{
										aux_title === undefined &&
										<b>{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}</b>
									}
									{
										aux_title === 0 &&
										<b>{ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : t('data-lang-lbl-chart')}</b>
									}
									<div className='toolbar d-flex'>
										<HEADER_TOOLBAR
											inputParam_BoardStructure={inputParam_BoardStructure}
											inputParam_Container={inputParam_Container}
										/>
									</div>
								</Card.Title>
							</Card.Header>
						}
					</>
				}
				<Card.Body className='h-100 ps-0 pe-2 pt-2'>
				{
						inputParam_ComponentContent ?
						<Row className='ps-0 pe-2 h-100'>
							{
								inputParam_ShowGauge &&
									<ChartGaugeOPF
										inputParam_Title={ inputParam_ComponentContent !== null && inputParam_ComponentContent.boardComponentTitle !== null ? inputParam_ComponentContent.boardComponentTitle : null}
										inputParam_ComponentContent={inputParam_ComponentContent.items[0]}
										selectedGaugeDataPointIndex={selectedGaugeDataPointIndex}
									/>
							}
							{
								chartConfig &&
								<Col className='p-0 m-0 col-xl-8'>
									<ReactApexChart
										ref={chartRef}
										type="bar"
										series={ listSeriesX }
										options={{
											title: {
												text: inputParam_ReportMode ? "" : getTitleSubTitle(),
												align: 'center',
											},
											colors: ['#1F7BE8', '#000099', '#FF8000'],
											chart: {
												height: 350,
												type: 'bar',
												stacked: false,
												events: {
													dataPointSelection: (event, chartContext, config) => { 
														setTimeout(() => {
															setSelectedGaugeDataPointIndex(config.dataPointIndex);
														}, 10);
													}
												},
												toolbar: {
													tools: {
														customIcons: [{
															icon: `<i class="ms-Icon ms-Icon--FileComment" aria-hidden="true"></i>`,
															index: -1,
															title: t('data-lang-lbl-charttooltiplegend'),
															class: 'custom-legeng-chart',
															click: toggleIsCalloutVisible
														}]
													}
												}
											},
											dataLabels: {
												enabled: (currentAuth.token.clientId.toUpperCase().startsWith('00BC62B1') && currentAuth.token.clientId.toUpperCase().endsWith('8FEA9592BD56') && currentAuth.token.clientId.toUpperCase().indexOf('51B0-47B4-8FB0') !== -1) ? true : false,
												formatter: (val) => {
													if (val === null || val === undefined || val === "") return ""; // sin dato
													const n = Number(val);
													if (!Number.isFinite(n)) return ""; // sin dato
													return n === 0 ? "0" : "";          // SOLO mostrar cuando es 0
												},
												offsetY: -20,
												style: {
													fontSize: "12px", 
													colors: ['#000']
												}
											},
											plotOptions: {
												bar: {
													dataLabels: {
														position: 'top'
													}
												}
											},
											stroke: {
												width: [2, 2, 2],
												dashArray: [0, 0, 5]
											},
											xaxis: {
												categories: listSerieTimeY,
											},
											yaxis: _baseSerieNames,
											tooltip: {
												fixed: {
													enabled: true,
													position: 'topLeft',
													offsetY: 30,
													offsetX: 60
												},
											},
											legend: {
												horizontalAlign: 'center',
												offsetX: 40
											},
											responsive: [{
												breakpoint: undefined,
												options: {},
											}],
										}}
										height={"100%"}
									/>
									{isCalloutVisible &&
										<Callout
											role="dialog"
											gapSpace={0}
											target={`.custom-legeng-chart`}
											onDismiss={toggleIsCalloutVisible}
											setInitialFocus
											className={styles.callout}
										>
											<Text as="h1" block variant="xLarge"> { t('data-lang-lbl-chartlegend') } </Text>
											<Text className='pb-2' block variant="small">
												<Row>
													<Col className='col-auto'>
														<b>{`aTit:`}</b> {`Ttile`}
													</Col>
												</Row>
											</Text>
										</Callout>
									}
								</Col>
							}
						</Row>
						: <NoDataLayer display={ true } />
					}
				</Card.Body>
			</Card>
}

SG3KPI_LASTOPF.propTypes = {
  	inputParam_Height: PropTypes.number,
  	inputParam_ReportMode: PropTypes.bool,
};

export default SG3KPI_LASTOPF;